import React from 'react';
import { connect } from 'react-redux';
//style
import './widget.styl';
//widget
import { widgetSetUp, widgetStart,resetWidget } from './widget';

class WidgetComponent extends React.Component {

    componentDidMount(){
        widgetSetUp(this.props.isStatic,this.props.widgetContainer,{displayScore:this.props.displayScore,solidBackground:this.props.solidBackground});
        if(this.props.aqi>=0){
            widgetStart(this.props.aqi, this.props.isStatic,this.props.widgetContainer,{displayScore:this.props.displayScore,solidBackground:this.props.solidBackground, locale: this.props.locale});
        }
    }

    componentWillReceiveProps(nextProps){
        setTimeout(() => {
            if(nextProps.aqi>=0) {
                widgetStart(nextProps.aqi, nextProps.isStatic, nextProps.widgetContainer, {displayScore: nextProps.displayScore, locale: this.props.locale});
            }else{
                resetWidget( nextProps.widgetContainer);
            }
        }, 100);

    }

    render(){
        return (
            <div className='widget-container'>
                <div  id={this.props.widgetContainer? this.props.widgetContainer:'widget-container'}>
                    {this.props.children}
                </div>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
  return {
    locale: state.locale.value,
  };
};

export default connect(mapStateToProps, null)(WidgetComponent);



// WEBPACK FOOTER //
// ./src/components/widget/WidgetComponent.js